import moment from 'moment'
import { formatMoney as formatDisplayMoney } from '../../../../services/moneyFormat'
import {
  formatDate as formatDisplayDate,
  formatDateLong as formatDisplayDateLong,
  isoEndOfDay as formatIsoEndOfDay,
  isoStartOfDay as formatIsoStartOfDay,
  parseDate,
  unixEndOfDay as formatUnixEndOfDay,
  unixStartOfDay as formatUnixStartOfDay
} from '../../../../services/dateFormat'

moment.locale('ru')

export function formatDate(value, fallback = '—') {
  return formatDisplayDate(value, fallback)
}

export function formatDateLong(value, fallback = '—') {
  return formatDisplayDateLong(value, fallback)
}

export function formatReportPeriod(filters) {
  if (!filters || !filters.start || !filters.end) {
    return 'Период не выбран'
  }
  return `${formatDateLong(filters.start)} — ${formatDateLong(filters.end)}`
}

export function formatMoney(value, options = {}) {
  return formatDisplayMoney(value, { ...options, invalid: String(value) })
}

export function formatVatRate(value) {
  if (value === null || value === undefined || value === '') {
    return '—'
  }
  const normalized = String(value)
  if (normalized.indexOf('%') !== -1) {
    return normalized
  }
  return `${normalized}%`
}

export function formatCounterpartyName(row) {
  if (!row) {
    return '—'
  }
  return row.contr_name || row.counterparty || row.name || '—'
}

export function formatDiagnosticLevel(level) {
  const levels = {
    info: 'Информация',
    warning: 'Предупреждение',
    error: 'Ошибка'
  }
  return levels[level] || 'Информация'
}

export function diagnosticColor(level) {
  const colors = {
    info: 'info',
    warning: 'warning',
    error: 'negative'
  }
  return colors[level] || 'info'
}

export function normalizePeriodToNdsCode(filters) {
  const start = parseDate(filters.start)
  const quarter = start.quarter()
  const year = start.year()
  return {
    year: String(year),
    period: `${quarter}${year}`
  }
}

export function unixStartOfDay(value) {
  return formatUnixStartOfDay(value)
}

export function unixEndOfDay(value) {
  return formatUnixEndOfDay(value)
}

export function isoStartOfDay(value) {
  return formatIsoStartOfDay(value)
}

export function isoEndOfDay(value) {
  return formatIsoEndOfDay(value)
}

export function buildDownloadedFileName(response, fallback) {
  const serverName = response && response.name
  if (!serverName) return fallback
  return `${String(serverName).replace(/\.[^./\\]+$/, '')}.xml`
}

export function downloadBlob(url, filename) {
  return fetch(url)
    .then((res) => {
      if (!res.ok) {
        throw new Error('download_failed')
      }
      return res.blob()
    })
    .then((file) => {
      const objectUrl = URL.createObjectURL(file)
      const anchor = document.createElement('a')
      anchor.href = objectUrl
      anchor.download = filename
      anchor.setAttribute('target', '_blank')
      document.body.appendChild(anchor)
      anchor.click()
      anchor.remove()
      setTimeout(() => URL.revokeObjectURL(objectUrl), 60 * 1000)
      return true
    })
}
